export default "__VITE_ASSET__ClLNq8_e__"